import React from 'react';
import { sanitizeHTML } from '@/core/hooks/useSanitizedHTML';
interface Block {
	show: boolean;
	content: string;
}

interface ConditionalBlockProps {
	block: Block;  // Блок с show и content, который нужно проверить
	children: React.ReactNode;  // Готовый элемент-компонент, который нужно отобразить, если HTML-контента нет
}

// <ConditionalBlock block={resultBreadcrumb}>
// 	<Breadcrumbs items={breadcrumbItems} />
// </ConditionalBlock>

function isBlockVisible(block: Block): string | boolean | null {
	if (!block.show) return null;
	return block.content.trim() ? block.content : true;
}

const ConditionalBlock: React.FC<ConditionalBlockProps> = ({ block, children }) => {
	const visibleContent = isBlockVisible(block);

	if (visibleContent === null) return null;

	if (typeof visibleContent === 'string') {
		return <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(visibleContent) }} />;
	}

	return <>{children}</>;
};

export default ConditionalBlock;

